var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.latestNewsLoading)?_c('div',[_c('BlockHorizontalList',{attrs:{"background-color":_vm.backgroundColor,"title":"Fortsätt läsa","type":"articles","articles":_vm.filteredNews}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }